/**
 * 在同一实体文件夹内按既有名称(1)规则分配唯一标题。
 * 完整投影和名称增量必须使用同一规则，后缀只作用于 UI，不能回写业务名称。
 * @param baseLabel 未经本轮去重的原始实体名称。
 * @param usedLabels 当前文件夹已占用的标题，按显示顺序累计。
 * @returns 本节点的唯一显示标题。
 */
export function resolveUniqueBodyTreeNodeLabel(baseLabel: string, usedLabels: Set<string>): string {
	const normalized = baseLabel.trim() || "实体";
	if (!usedLabels.has(normalized)) {
		usedLabels.add(normalized);
		return normalized;
	}
	let suffix = 1;
	while (usedLabels.has(`${normalized}(${suffix})`)) suffix += 1;
	const unique = `${normalized}(${suffix})`;
	usedLabels.add(unique);
	return unique;
}
